import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/AuthContext";
import { LoadingScreen } from "@/components/common/LoadingScreen";
import { isAdminRole } from "@/features/auth/roles";
import { ROUTES } from "@/constants/routes";

/**
 * Guard for the shared /admin/* console. Any of the four admin-flavoured
 * roles (super_admin, operations_admin, store_admin, staff) may enter — the
 * console itself applies fine-grained RBAC + store scoping.
 *
 * Non-admin roles are bounced to their own login portal, never to the
 * customer home (strict role isolation).
 */
export function AdminRoute() {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return <LoadingScreen label="Checking admin session…" />;
    }
    if (status !== "authenticated" || !user) {
        return (
            <Navigate
                to={ROUTES.superAdminLogin}
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }
    if (!isAdminRole(user.role)) {
        // Send to the login portal that matches their role — no cross-role bleed.
        const target =
            user.role === "rider"
                ? ROUTES.riderLogin
                : ROUTES.login;
        return <Navigate to={target} replace />;
    }
    return <Outlet />;
}

export default AdminRoute;
